export const MonthOption = {
  DayOfTheMonth: 'Day of the month',
  WeekOfTheMonth: 'Week of the month',
};
